import type { CSSProperties } from 'react'

import React, { forwardRef, useContext } from 'react'
import { CarouselContext } from '..'
import type { Preset } from '..'
import styles from './styles.module.css'
import { cn } from '@s4l/utility-css'

export type IPropsContent = {
  itemsPerPage?: [number, number, number]
  initialItemIndex?: number
  preset?: Preset
  children: React.ReactNode
}
export const Content = forwardRef<HTMLDivElement, IPropsContent>(
  ({ children, itemsPerPage, initialItemIndex, preset }, ref) => {
    const { variant } = useContext(CarouselContext)

    if (preset === 'single-items' && itemsPerPage !== undefined) {
      console.error('itemsPerPage must be undefined when preset is single-items')
      return null
    }
    if (preset === 'multiple-items' && itemsPerPage === undefined) {
      console.error('itemsPerPage must be defined when preset is multiple-items')
      return null
    }
    if (preset === 'multiple-items' && initialItemIndex !== undefined) {
      console.error('initialItemIndex must be undefined when preset is multiple-items')
      return null
    }

    const nextChildren = React.Children.map(children, child => {
      const [mobileItems, tabletItems, desktopItems] = itemsPerPage ?? [1, 1, 1]
      return (
        <div
          className={styles.slide}
          style={
            {
              '--item-per-page-sm': mobileItems,
              '--item-per-page-md': tabletItems,
              '--item-per-page-lg': desktopItems,
            } as CSSProperties
          }
        >
          {child}
        </div>
      )
    })

    return (
      <div
        ref={ref}
        className={cn(styles.viewport, variant && styles[variant])}
        data-testid="carousel-content"
        style={
          {
            '--slide-gap': preset === 'multiple-items' ? 'var(--space-16)' : 'var(--space-0)',
          } as CSSProperties
        }
        data-preset={preset}
        data-embla-viewport
      >
        <div className={styles.container}>{nextChildren}</div>
      </div>
    )
  }
)

Content.displayName = 'Carousel.Content'
